/**
 * FCM 토큰 관련 유틸리티
 * - Flutter 앱에서 WebView로 주입된 FCM 토큰을 관리
 */

/**
 * FCM 토큰 가져오기
 * - Flutter 앱에서 localStorage에 저장한 토큰을 반환
 * @returns {string|null} FCM 토큰 또는 null
 */
export function getFcmToken() {
  try {
    return localStorage.getItem('fcmToken');
  } catch (e) {
    return null;
  }
}

/**
 * FCM 토큰 저장
 * @param {string} token - FCM 토큰
 */
export function setFcmToken(token) {
  try {
    localStorage.setItem('fcmToken', token);
  } catch (e) {
    // 저장 실패 시 특별한 처리 없음
  }
}

/**
 * FCM 토큰 삭제
 */
export function removeFcmToken() {
  try {
    localStorage.removeItem('fcmToken');
  } catch (e) {
    // 삭제 실패 시 특별한 처리 없음
  }
}

/**
 * 모바일 앱 환경인지 확인
 * - Flutter WebView에서 실행 중인지 확인
 *
 * [수정] 앱 재실행 시 로그인 유지 안 되는 버그
 * - clearLocalStorage()로 fcmToken이 삭제된 상태에서 페이지 로드
 * - fcmToken 주입은 onPageFinished(비동기)에서 실행되어 useEffect보다 늦을 수 있음
 * - FlutterChannel도 타이밍에 따라 아직 미주입될 수 있음
 * → User-Agent 기반 모바일 감지를 추가하여, 앱 WebView에서 refresh 시도를 보장
 *
 * @returns {boolean}
 */
export function isMobileApp() {
  if (typeof window === 'undefined') return false;

  // 1) Flutter에서 주입한 FlutterChannel (가장 확실)
  const hasFlutterChannel = window.FlutterChannel !== undefined;
  if (hasFlutterChannel) return true;

  // 2) FCM 토큰 (clearLocalStorage 후 재실행 시 null일 수 있음)
  const hasFcmToken = getFcmToken() !== null;
  if (hasFcmToken) return true;

  // 3) User-Agent 기반 모바일 감지 (Flutter WebView는 모바일 UA 사용)
  // - 앱 재실행 시 1,2가 타이밍상 아직 준비되지 않았을 수 있음
  // - 모바일 UA면 refresh 시도 (앱: 쿠키 있음→성공, 모바일웹: 쿠키 없음→실패해도 무방)
  const ua = navigator.userAgent || '';
  const isMobileUa = /Android|iPhone|iPad|iPod|Mobile/i.test(ua);
  if (isMobileUa) return true;

  return false;
}

// Flutter에서 호출할 전역 콜백 함수 등록
if (typeof window !== 'undefined') {
  window.onFcmTokenReceived = (token) => {
    setFcmToken(token);
    // 커스텀 이벤트 발생 (필요한 경우 사용)
    window.dispatchEvent(new CustomEvent('fcmTokenReceived', { detail: { token } }));
  };
}
